import { render, staticRenderFns } from "./MultiplasLotacoes.vue?vue&type=template&id=5aefa92c&scoped=true&"
import script from "./MultiplasLotacoes.vue?vue&type=script&lang=js&"
export * from "./MultiplasLotacoes.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./MultiplasLotacoes.vue?vue&type=style&index=1&id=5aefa92c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aefa92c",
  null
  
)

export default component.exports